export function DropdownDivider() {
  return <div className="DropdownDivider" />
}
